import { render } from "./MyVacationYearAdditionalInfos.vue?vue&type=template&id=609d0fa0"
import script from "./MyVacationYearAdditionalInfos.vue?vue&type=script&lang=js"
export * from "./MyVacationYearAdditionalInfos.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__